import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

// lista de logs
export const getLogs = async () => {
    const { data } = await axios.get(API_ROUTES.LOGS);
    return data;
};

// Descargar log (blob)
export const downloadLog = async (filename) => {
    const response = await axios.get(`${API_ROUTES.LOGS}/download/${filename}`, {responseType: 'blob'});
    return response.data;
};